<template>
  <div class="page-insurance-introduction">
    <div class="banner">
      <swiper ref="mySwiper" class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in media_list" :key="index">
          <div class="video-box" v-if="item.type === 'video'">
            <video
              ref="insuranceVideo"
              @ended="pauseVideo"
              @play="clickVideoPlayTracking"
              :src="item.url"
              controls="controls"
            >
              您的浏览器不支持 video 标签。
            </video>
            <div v-if="videoOverlay" class="play-control" @click="videoPlay">
              <img
                src="https://select-oil-oss.vchangyi.com/wxapp/icon-play.png"
                alt=""
              />
            </div>
          </div>
          <img
            class="swiper-img"
            @click="previewImg(item.url)"
            v-if="item.type === 'img'"
            :src="item.url"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="introduction">
      <p class="introduction-title">2023太平洋安心保简介</p>
      <p class="introduction-main">
        在保险期间内遭受意外伤害,并且自意外伤害发生之日起180天内以该次意外伤害为直接原因身故,给付身故保险金,保险合同终止。
      </p>
      <p class="introduction-item-title">1、意外伤害</p>
      <p class="introduction-item-main">
        意外身故＋伤残最高赔付20000元；意外门诊医疗，最高5000元；住院医疗报销，最高36000元。
      </p>
      <p class="introduction-item-title">2、意外门诊医疗</p>
      <p class="introduction-item-main">
        在保险期间内，若被保险人遭受意外伤害而在境内二级以上或保险公司认可的医疗机构进行门诊治疗，给付规定可报销的合理且必要的门诊医疗费用，在扣除被保险人从其他途径获得的补偿进行赔付，一次或累计达到保险金额时，本附加保险责任终止
      </p>
      <p class="introduction-item-title">3、住院医疗</p>
      <p class="introduction-item-main">
        100元免赔，按比例给付，疾病住院90天等待期，续保无等待期，最高36000元
      </p>
      <div class="introduction-banner">
        <img src="@/assets/home/top.png" alt="" />
      </div>
      <p class="introduction-item-title">
        2022太平洋安心保互联网值得买吗？在哪买？
      </p>
      <p class="introduction-item-main">
        太平洋安心保互联网专为未成年人定制，安心保少儿疾病住院医疗保障全面，安心保、抵免赔，100元以上即可报销；无社保也可投保，适合中国境内二级及以上公立医院；适合出生满28天的萌宝、初入幼儿园宝贝、活泼好动的小学生、特立独行的青春期少年投保，一年264元，门槛低。
      </p>
    </div>
    <!-- 点击分享按钮 -->
    <fab-share-button @clickButton="toFloatDetail"></fab-share-button>
    <!-- 底部按钮 -->
    <div class="bottom">
      <button class="button left-button" @click="showDialog">立即咨询</button>
      <button class="button right-button" @click="toInsurePage">
        我要投保
      </button>
    </div>
    <!-- 二维码分享浮窗 -->
    <div class="qr-code-dialog" @touchmove.stop.prevent v-if="qrCodeShow">
      <div class="close-button">
        <div class="inner-box" @click="closeDialog">
          <img
            src="@/assets/insurance/insurance-circle-close-icon.png"
            alt=""
            class="close-icon"
          />
        </div>
      </div>
      <div class="img-box">
        <img
          src="@/assets/insurance/insurance-qr-code.png"
          alt=""
          class="qr-code"
        />
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import wx from "weixin-js-sdk";
import { wxConfig } from "@/plugins/WxConfig.js";
import api from "@/apis/insurance-api.js";
import FabShareButton from "./components/FabShareButton.vue";
export default {
  name: "InsurancePoster",
  components: { Swiper, SwiperSlide, FabShareButton },
  data() {
    return {
      activeIndex: 0, //当前轮播索引
      qrCodeShow: false, //咨询二维码弹窗是否展示
      videoOverlay: true, //轮播中的视频播放控制
      is_wx: this.browser.wx, //是否是微信环境
      hasPlay: false, //是否已经播放过（判断用户点击播放仅埋点一次）
      media_list: [
        //轮播图片、视频资源
        {
          type: "video",
          url: "http://1300905495.vod2.myqcloud.com/6f89ba2evodtranscq1300905495/3484492f387702299624129210/v.f20.mp4",
        },
        {
          type: "video",
          url: "http://1300905495.vod2.myqcloud.com/6f89ba2evodtranscq1300905495/3484492f387702299624129210/v.f20.mp4",
        },
        {
          type: "img",
          url: "https://dummyimage.com/375x375.png/f7eae2/333",
        },
        {
          type: "img",
          url: "https://dummyimage.com/375x375.png/eadb80/333",
        },
        {
          type: "img",
          url: "https://dummyimage.com/375x375.png/aeddef/333",
        },
        {
          type: "img",
          url: "https://dummyimage.com/375x375.png/e1b4d3/333",
        },
        {
          type: "img",
          url: "https://dummyimage.com/375x375.png/fbc70c/333",
        },
      ],
      //swiper配置
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          // dynamicBullets: true,
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper.$swiper;
            this.activeIndex = swiper.activeIndex;
            this.$refs.insuranceVideo[0].pause();
            this.$refs.insuranceVideo[1].pause();
          },
        },
      },
      imageAgent: "https://select-oil-api-new.chedianai.com/image_agent?image="
    };
  },
  mounted() {
    wxConfig(); //H5配置js-sdk
    this.visitTracking(); //访问埋点
  },
  async beforeDestroy() {
    await this.leaveInsuranceTracking(); //在vue项目内部跳转时（即离开页面时埋点）
  },
  methods: {
    /**
     * 点击控制层播放视频
     */
    videoPlay() {
      if (this.$refs.insuranceVideo[0].paused) {
        this.$refs.insuranceVideo[0].play();
        this.videoOverlay = false;
      } else {
        this.$refs.insuranceVideo[0].pause();
        this.videoOverlay = true;
      }
    },
    /**
     * 预览图片
     * @param {string} url
     */
    previewImg(url) {
      if (this.is_wx) {
        wx.previewImage({
          current: "",
          urls: [this.imageAgent + url], // 需要预览的图片 http 链接列表
        });
      } else {
        this.h5Preview([this.imageAgent + url]);
      }
    },
    /**
     * H5查看图片方法
     * @author 田月荣 <tianyuerong@vchangyi.com>
     * @param {array} imgsArr - 预览图片数组
     * @param {number} idx - 当前图片索引
     */
    h5Preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    /**
     * 播放结束，暂停视频并显示播放按钮
     */
    pauseVideo() {
      this.$refs.insuranceVideo[0].pause();
      this.videoOverlay = true;
    },

    /**
     * 跳转投保页面（点击我要投保）
     * 用a标签跳转的或者location.href跳转不会触发beforeDestroy等生命周期，在此主动调用离开埋点接口
     */
    async toInsurePage() {
      await this.clickInsureTracking(); //点击“我要投保”按钮埋点
      await this.leaveInsuranceTracking(); //离开页面埋点
      window.location.href = "https://jinshuju.net/f/H2xKiK"; //第三方投保相关页面
    },
    /**
     * 访问页面埋点（获取visit_id）
     */
    async visitTracking() {
      this.$loading.show("加载中...");
      try {
        const res = await api.visitInsuranceTrackingApi({
          ...this.$route.query,
          no_iswx: true,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.visit_id = res.data.visit_id;
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    /**
     * 点击视频埋点
     */
    async clickVideoPlayTracking() {
      if (this.has_play) return;
      this.has_play = true;
      const params = {
        visit_id: this.visit_id,
      };
      try {
        const res = await api.clickVideoPlayTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击视频埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击视频埋点失败-error", error);
      }
    },
    /**
     * 点击我要咨询埋点
     */
    async clickConsultTracking() {
      const params = {
        visit_id: this.visit_id,
      };
      try {
        const res = await api.clickConsultTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击我要咨询埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击我要咨询埋点失败-error", error);
      }
    },
    /**
     * 点击我要投保按钮埋点
     */
    async clickInsureTracking() {
      const params = {
        visit_id: this.visit_id,
      };
      try {
        const res = await api.clickInsureTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击我要投保按钮埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击我要投保按钮埋点失败-error", error);
      }
    },
    /**
     * 用户离开安心保落地页埋点
     */
    async leaveInsuranceTracking() {
      const params = {
        visit_id: this.visit_id,
      };
      try {
        const res = await api.leaveInsuranceTrackingApi(params);
        if (res.code !== 0) {
          console.log("用户离开安心保落地页埋点异常-response", res);
        }
      } catch (error) {
        console.log("用户离开安心保落地页埋点失败-error", error);
      }
    },
    /**
     * 点击悬浮窗跳转保存海报页面
     */
    async toFloatDetail() {
      this.$router.push({
        name: "insurance-poster",
        query: {
          visit_id: this.visit_id,
        },
      });
    },
    /**
     * 关闭二维码弹窗
     */
    closeDialog() {
      this.qrCodeShow = false;
    },
    /**
     * 展示二维码弹窗（点击立即咨询）
     */
    async showDialog() {
      await this.clickConsultTracking();
      this.qrCodeShow = true;
    },
  },
};
</script>
<style lang="less" scoped>
.swiper {
  --swiper-pagination-color: #fad84c; //分页指示器颜色
}
.video-box {
  width: 640/100rem;
  height: 640/100rem;
  position: relative;
  video {
    width: 100%;
    height: 100%;
  }
  .play-control {
    position: absolute;
    z-index: 22;
    top: 0;
    left: 0;
    width: 640/100rem;
    height: 640/100rem;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 79/100rem;
      height: 79/100rem;
    }
  }
  .swiper-img {
    width: 640/100rem;
    height: 640/100rem;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 85%;
    // background: skyblue;
  }
}
.page-insurance-introduction {
  background: #fafafa;
  .introduction {
    box-sizing: border-box;
    padding: 0 26/100rem;
    padding-bottom: 162/100rem;
  }
  .introduction-title {
    font-size: 31/100rem;
    line-height: 43/100rem;
    color: #000;
    font-weight: bold;
    margin: 26/100rem 0;
  }
  .introduction-main {
    font-size: 24/100rem;
    font-weight: 400;
    color: #808080;
    line-height: 34/100rem;
  }
  .introduction-item-title {
    font-size: 24/100rem;
    font-weight: bold;
    color: #404040;
    line-height: 34/100rem;
    margin: 26/100rem 0 17/100rem 0;
  }
  .introduction-item-main {
    font-size: 24/100rem;
    font-weight: 400;
    color: #808080;
    line-height: 34/100rem;
  }
  .introduction-banner {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 26/100rem;
    img {
      width: 589/100rem;
      height: 273/100rem;
    }
  }
  .bottom {
    width: 100%;
    height: 162/100rem;
    position: fixed;
    bottom: 0;
    left: 0;
    // background: #fafafa;
    display: flex;
    justify-content: center;
    .button {
      width: 282/100rem;
      height: 75/100rem;
      margin-top: 53/100rem;
      display: flex;
      line-height: 0;
      justify-content: center;
      align-items: center;
      border-radius: 38/100rem;
      font-weight: bold;
      font-size: 27/100rem;
    }
    .left-button {
      border: 2/100rem solid #fbc70d;
      margin-right: 13/100rem;
      background: #fafafa;
      color: #fbc70d;
    }
    .right-button {
      margin-left: 13/100rem;
      color: #000;
      background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%) #ffffff;
    }
  }
}
.banner {
  width: 640/100rem;
  height: 640/100rem;
  margin: 0 auto;
  img {
    width: 640/100rem;
    height: 640/100rem;
  }
}

// 二维码弹窗
.qr-code-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background: rgba(00, 00, 00, 0.75);
  display: flex;
  flex-direction: column;
  .close-button {
    margin-top: 176/100rem;
    width: 100%;
    height: 77/100rem;
    display: flex;
    justify-content: flex-end;
    .inner-box {
      width: 171/100rem;
      height: 77/100rem;
      display: flex;
      justify-content: center;

      .close-icon {
        width: 41/100rem;
        height: 41/100rem;
      }
    }
  }
  .img-box {
    width: 469/100rem;
    height: 683/100rem;
    margin: 0 auto;
    .qr-code {
      width: 469/100rem;
      height: 683/100rem;
    }
  }
}
</style>
